import { render, staticRenderFns } from "./FilterSelectTestimonialSources.vue?vue&type=template&id=c90886fa&scoped=true&"
import script from "./FilterSelectTestimonialSources.vue?vue&type=script&lang=js&"
export * from "./FilterSelectTestimonialSources.vue?vue&type=script&lang=js&"
import style0 from "./FilterSelectTestimonialSources.vue?vue&type=style&index=0&id=c90886fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90886fa",
  null
  
)

component.options.__file = "FilterSelectTestimonialSources.vue"
export default component.exports